import React from "react";
import { Route, Routes } from "react-router-dom";
import ErrorFallback from "./errorHandler/ErrorFallback";
import NotFound from "./errorHandler/NotFound";
import Unauthorized from "./errorHandler/Unauthorized";
import AuthGuard from "./AuthGuard";
import AppContent from "./AppContent";
import RiderContent from "./RideContent";
import ProcessCsvOrders from "./ProcessCsvOrders";

function AppRoute() {
  return (
    <Routes>
      <Route element={<AuthGuard />}>
        <Route path="/home" element={<AppContent />} />
        <Route path="/rider" element={<RiderContent />} />
        <Route path="/orders/upload" element={<ProcessCsvOrders />} />
      </Route>
      <Route path="/error-fallback" element={<ErrorFallback />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoute;
